import { RefObject } from 'react';

// Components
import { ImageFallback } from '@shared/ui';

// Constants
import { UserRole } from '@shared/constants';

// Utils
import { combineClasses } from '@shared/utils';
import { getUpdatedLogoUrl, getUserRole } from '@/utils';

// Types
import { Project } from '@shared/types';

// Helpers
import { getProjectMentionText } from './helpers';
export interface ProjectMentionItemProps {
  project: Project;
  index: number;
  isSelected: boolean;
  selectedProjectRef: RefObject<HTMLButtonElement | null>;
  onProjectSelect: (project: Project) => void;
}
export const ProjectMentionItem = ({
  project,
  index,
  isSelected,
  selectedProjectRef,
  onProjectSelect
}: ProjectMentionItemProps) => {
  const displayName = getProjectMentionText(project);
  const userRole = getUserRole();
  const isUser = userRole === UserRole.USER;
  const isArchived = project.projectInfo?.archived;
  if (isArchived && isUser) return null;
  const {
    id = '',
    logo = '',
    code = '',
    updatedAt = ''
  } = project.projectInfo || {};
  const handleProjectClick = () => {
    onProjectSelect(project);
  };
  const updatedLogoUrl = getUpdatedLogoUrl(logo, updatedAt);
  return <button data-testid={`project-mention-item-${index}`} key={id} ref={isSelected ? selectedProjectRef : null} tabIndex={-1} role="option" aria-selected={isSelected} onClick={handleProjectClick} className={combineClasses('flex w-full items-center gap-3 px-5 py-3 text-left transition-colors', 'focus:outline-none', isSelected ? 'bg-primary-100' : 'hover:bg-primary-100')} data-sentry-component="ProjectMentionItem" data-sentry-source-file="ProjectMentionItem.tsx">
      {/* Project Logo */}
      <div className="flex-shrink-0">
        {logo ? <ImageFallback src={updatedLogoUrl} // Ensure cache busting for updated logo image
      alt={`${displayName} logo`} width={30} height={30} className="size-7.5 rounded-full" /> : <div className="size-7.5 bg-frost-250 rounded-full" />}
      </div>

      {/* Project Info */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <p className={`text-xs truncate ${isArchived ? 'text-frost-500' : 'text-black'}`}>
            {code}
          </p>
          {isArchived && <span className="text-xs text-frost-500" data-testid={`project-archived-${index}`} id={`project-archived-${index}`} aria-label="Project is archived">
              Archived
            </span>}
        </div>
      </div>
    </button>;
};